if (!customElements.get('product-recommendations')) {
  customElements.define(
    'product-recommendations',
    class ProductRecommendations extends HTMLElement {
      connectedCallback() {
        const loadRecommendations = () => {
          if (this.dataset.loaded === 'true') return;
          this.dataset.loaded = 'true';

          const separator = this.dataset.url.includes('?') ? '&' : '?';
          const url =
            this.dataset.url +
            separator +
            'section_id=' +
            encodeURIComponent(this.dataset.sectionId) +
            '&product_id=' +
            encodeURIComponent(this.dataset.productId);

          fetch(url)
            .then((response) => {
              if (!response.ok) throw new Error('Product recommendations request failed');
              return response.text();
            })
            .then((text) => {
              const html = new DOMParser().parseFromString(text, 'text/html');
              const recommendations = html.querySelector('product-recommendations');

              if (recommendations && recommendations.innerHTML.trim().length) {
                this.innerHTML = recommendations.innerHTML;
              }
            })
            .catch(() => {
              this.dataset.loaded = 'false';
            });
        };

        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver(
            (entries, currentObserver) => {
              if (!entries[0].isIntersecting) return;
              currentObserver.unobserve(this);
              loadRecommendations();
            },
            { rootMargin: '0px 0px 400px 0px' }
          );
          observer.observe(this);
        } else {
          loadRecommendations();
        }
      }
    }
  );
}
